import { Button, Table } from '@dixa/lib-shared-habla';

import styles from './tableFailedRow.module.scss';

type PropsT = {
  colSpan?: number;
  handleRetry?: () => void;
};

export const TableFailedRow = ({ colSpan, handleRetry }: PropsT) => (
  <Table.Tr>
    <Table.Td align="center" colSpan={colSpan}>
      <div className={styles.text}>Something went wrong...</div>
      <Button variant="tertiary" onClick={handleRetry}>
        Try again
      </Button>
    </Table.Td>
  </Table.Tr>
);
